import CardMetric from './CardMetric';

export default CardMetric;
